<script>
export default {
    name: "MasterCellGhost",
    functional: true,
    props: {
      cellConfig: Object
    },

    render(h, context) {
        if (context && context.children[context.data.key].context) {
            context.children[context.data.key].componentOptions.propsData = context.children[context.data.key].componentOptions.propsData;
            context.children[context.data.key].componentOptions.propsData.config = context.props.cellConfig;
    
            return context.children[context.data.key];
        }
    }
};
</script>